import { useTranslation } from 'react-i18next';
import CardEventsDetails from './CardEventsDetails';
import ChevronIcon from '../icons/chevronIcon';
import { useHistory } from 'react-router-dom';
import styles from './CardEventsDetails.module.css';

const ContainerEventsDetails = ({ events }) => {
  const { t } = useTranslation();
  const history = useHistory();

  if (!events || events.length === 0) {
    return null;
  }

  return (
    <div className='card px-2 mt-2'>
      <div className='card-header'>{t('yourEtickets')}</div>
      <div className={styles.eventList}>
        {events.map((event) => (
          <CardEventsDetails
            key={event.id}
            eventSubName={event.eventShow === null ? event.city?.name : event.restaurantName}
            reservationType={event.reservationType}
            pax={event.pax}
            bannerImage={event.eventShow?.bannerImage || event.restaurantBanner}
            eventName={event.eventShow?.name || event.restaurantName}
            startDate={event.eventShow?.startDate || event.reservationLocalTime}
            onClick={() => {
              history.push(`/ticket-details?ticketId=${event.id}`);
            }}
          />
        ))}
      </div>
      <div className='card-footer'>
        <div
          className={`text-secondary d-flex justify-content-between`}
          onClick={() => {
            history.push(`/e-tickets`);
          }}
        >
          <span>{t('viewAllYourEtickets')}</span>
          <ChevronIcon
            fillColor='#fff'
            size='20px'
            styles={{
              transform: 'rotate(180deg)',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ContainerEventsDetails;
